import { RoutesLocaleType } from "@typings/global.types";

export const DEFAULT_ROUTER_LOCALE = RoutesLocaleType.en;
export const SUPPORTED_ROUTER_LOCALE: string[] =
  Object.values(RoutesLocaleType);

export const GRID_BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1260,
};

export const IGNORE_LAYOUT_PROPERTY = [
  "colors",
  "parsedcolors",
  "acceptedKeys",
  "deadKey",
  "acceptedWithDeadKey",
  "specialKeyNames",
  "deadKeyElements",
  "shiftElements",
];

// локалі в яких рахуємо знаків на хвилину
export const LOCALE_WITH_SIGNS_PER_MINUTE = ["uk_UA", "ru_RU"];
